var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1063 0C4.52527 0 0 4.52476 0 10.1052C0 15.6857 4.52527 20.2105 10.1064 20.2105C12.2525 20.2105 14.2429 19.5411 15.8789 18.401L15.8801 18.3998L23.3754 25.8944C23.5145 26.0334 23.7357 26.037 23.8784 25.8944L25.8985 23.8745C26.0376 23.7354 26.0304 23.5048 25.8973 23.3716L18.4031 15.8783C19.5433 14.2412 20.2127 12.2511 20.2127 10.1052C20.2127 4.52476 15.6874 0 10.1063 0ZM10.1063 17.8327C5.83785 17.8327 2.37794 14.3732 2.37794 10.1052C2.37794 5.83723 5.8379 2.37771 10.1063 2.37771C14.3748 2.37771 17.8347 5.83723 17.8347 10.1052C17.8347 14.3732 14.3748 17.8327 10.1063 17.8327Z",
    fill: "#494949"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDark);
export default __webpack_public_path__ + "static/media/search-dark.4f446d6057f8f9a67b91e61492bf0e71.svg";
export { ForwardRef as ReactComponent };